 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		11: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		11: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"ddf651164a0cde596cac18a6c2f43477dc32fda0","3":"87219d336dbf01b176ff67de05b35e92a48e80f6","4":"17505c44ba1ab629bc64d4624568741a670e2955","5":"0f8d3750d0a290f8d54d18a0bb12b1eb1f4ebc76","6":"3160b95b2409e186509125643dd835329a79394d","7":"dbc31a2540cc76189e801e55c746d18f667b4462","8":"35dc2d76269770646ec0d5dfabef2a5f8ba5efb4","9":"ce519a5eb5e2a68d4e602c351c459190eb7976b9","10":"f222781cf8280ea8d3b105e892c7e112c3e4e424","13":"component---src-pages-404-index-tsx","14":"component---src-pages-cases-index-tsx","15":"component---src-pages-contacts-index-tsx","16":"component---src-pages-directions-index-tsx","17":"component---src-pages-directions-pages-backend-index-tsx","18":"component---src-pages-directions-pages-cdto-index-tsx","19":"component---src-pages-directions-pages-delivery-index-tsx","20":"component---src-pages-directions-pages-design-index-tsx","21":"component---src-pages-directions-pages-fintech-index-tsx","22":"component---src-pages-directions-pages-iot-index-tsx","23":"component---src-pages-directions-pages-kmm-index-tsx","24":"component---src-pages-directions-pages-restocare-index-tsx","25":"component---src-pages-index-tsx","26":"component---src-pages-order-index-tsx","27":"component---src-pages-privacy-policy-index-tsx","28":"component---src-pages-reviews-index-tsx","29":"component---src-pages-speeches-index-tsx","30":"component---src-pages-team-index-tsx","31":"component---src-pages-vacancies-index-tsx","32":"component---src-templates-blog-page-index-tsx","33":"component---src-templates-case-page-index-tsx","34":"component---src-templates-post-page-index-tsx","35":"component---src-templates-vacancy-page-index-tsx"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"866f62f7c5a8c7c3a51b","2":"d0c3f0c9926de53563b1","3":"86b8f55e3fe408f65b5b","4":"4d6f50dec9cedc98b9ea","5":"76caf3bf6c710376f52a","6":"dd96aa5591e62cd06728","7":"9826b09d260e33dc3a4c","8":"8187467be02262a53aa6","9":"5060c0801b9afee26139","10":"d832628f6e30eeff0c2b","13":"f55927dd51a656747696","14":"6591d0528a09c848206c","15":"024738a2d253d896b29f","16":"c99b31ff7ec9febdd206","17":"a2010caa1bd350a5f248","18":"cb5f47cc71f62f448fdd","19":"285468ef6af51b169cff","20":"58335c19e2f8514dd5f8","21":"0a90e3e3bbba6273c869","22":"35ea8503d29dd3e64cf0","23":"f11e65aacf0b8cbbb94d","24":"fceeb7c547db18a2f919","25":"772de41e9906e6f86726","26":"478ba79bf20ec7f108d8","27":"27c1d47bd18e834d87b5","28":"3039b87452023bb2cc09","29":"11eab157669eb8508fd0","30":"f8e1cbbe46d28821ec55","31":"3e05a9b62de196aa3eeb","32":"14316faf5cf85fe6a582","33":"35313352ad019b99b7ac","34":"864e2616fa8dc104cbd6","35":"193c8e909f020bffdda5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"ddf651164a0cde596cac18a6c2f43477dc32fda0","3":"87219d336dbf01b176ff67de05b35e92a48e80f6","4":"17505c44ba1ab629bc64d4624568741a670e2955","5":"0f8d3750d0a290f8d54d18a0bb12b1eb1f4ebc76","6":"3160b95b2409e186509125643dd835329a79394d","7":"dbc31a2540cc76189e801e55c746d18f667b4462","8":"35dc2d76269770646ec0d5dfabef2a5f8ba5efb4","9":"ce519a5eb5e2a68d4e602c351c459190eb7976b9","10":"f222781cf8280ea8d3b105e892c7e112c3e4e424","13":"component---src-pages-404-index-tsx","14":"component---src-pages-cases-index-tsx","15":"component---src-pages-contacts-index-tsx","16":"component---src-pages-directions-index-tsx","17":"component---src-pages-directions-pages-backend-index-tsx","18":"component---src-pages-directions-pages-cdto-index-tsx","19":"component---src-pages-directions-pages-delivery-index-tsx","20":"component---src-pages-directions-pages-design-index-tsx","21":"component---src-pages-directions-pages-fintech-index-tsx","22":"component---src-pages-directions-pages-iot-index-tsx","23":"component---src-pages-directions-pages-kmm-index-tsx","24":"component---src-pages-directions-pages-restocare-index-tsx","25":"component---src-pages-index-tsx","26":"component---src-pages-order-index-tsx","27":"component---src-pages-privacy-policy-index-tsx","28":"component---src-pages-reviews-index-tsx","29":"component---src-pages-speeches-index-tsx","30":"component---src-pages-team-index-tsx","31":"component---src-pages-vacancies-index-tsx","32":"component---src-templates-blog-page-index-tsx","33":"component---src-templates-case-page-index-tsx","34":"component---src-templates-post-page-index-tsx","35":"component---src-templates-vacancy-page-index-tsx"}[chunkId]||chunkId) + "." + {"0":"8c3f563896d2d86c4285","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
